<template>
  <div class="home">
    <navigation></navigation>
    <div class="homeBG">
    </div>
    <div class="bsright">
      <div class="bsrightBox">
        <div class="bsrightImg">
          <img :src="currentImage" alt="产品图片">
        </div>
        <div class="bsrightright">
          <div class="btzw">
            3521环保科技.产品系列
          </div>

          <div class="btyw">
            PRODUCT SERIES
          </div>

          <div style="height: 100%;">

            <div class="bsr" v-for="(item, index) in productList" :key="index" @mouseenter="changeImage(index)">
              <div class="bsa">
                {{ item.name }}
              </div>
              <div class="bsb"></div>
            </div>

          </div>
        </div>

      </div>

    </div>
    <div class="cationBox">
      <div>
        <div class="cationtext">
          应用场景
        </div>
        <div class="cationtext" style="font-size: 18px; margin-top: 10px;">
          APPLICATION SCENARIO
        </div>
      </div>
      <div class="cationContent" @mouseenter="handleMouseEnter(1)" @mouseleave="handleMouseLeave"
        :style="cationContentStyle">
        <div class="scene-grid">

          <div class="scene-item" v-for="(industry, index) in industries" :key="index"
            @mouseenter="changeSceneBackground(index)">
            <img :src="industry.icon" class="yytb" :alt="industry.name">
            <div class="scene-label">{{ industry.name }}</div>
          </div>

        </div>
      </div>

    </div>
    <dibu></dibu>
  </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from './dibu.vue';
export default {
  name: 'Home',
  components: {
    navigation,
    dibu
  },
  data() {
    return {
      productList: [
        { name: '环保滤袋' },
        { name: '环保滤筒' }
      ],
      currentImageIndex: 0,
      images: [
        require('../img/home1.jpg'),  // 环保滤袋对应home1
        require('../img/home2.jpg')   // 环保滤筒对应home2
      ],
      currentHoverIndex: null,
      industries: [
        { name: '电力行业', icon: require('../img/rongyu.svg') },
        { name: '钢铁行业 ', icon: require('../img/buliao.svg') },
        { name: '玻璃炉行业', icon: require('../img/tong.svg') },
        { name: '水泥行业', icon: require('../img/gongzuo.svg') },
        { name: '废物焚烧行业', icon: require('../img/feiwu.svg') }
      ],
      sceneBackgrounds: [
        require('../img/powerPlant.jpg'),
        require('../img/architecture.jpg'),
        require('../img/boli.jpg'),
        require('../img/factory.jpg'),
        require('../img/laji.jpg'),

      ]
    }
  },
  computed: {
    currentImage() {
      return this.images[this.currentImageIndex];
    },
    cationContentStyle() {
      if (this.currentHoverIndex !== null) {
        return {
          backgroundImage: `url(${this.sceneBackgrounds[this.currentHoverIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        };
      } else {
        return {
          backgroundImage: "url(" + require('../img/powerPlant.jpg') + ")",  // 默认背景
          backgroundSize: "cover",
          backgroundPosition: "center"
        };
      }
    }
  },
  methods: {
    changeImage(index) {
      this.currentImageIndex = index;
    },
    handleMouseEnter(index) {
      this.currentHoverIndex = index;  // 记录当前悬停的行业索引
    },
    handleMouseLeave() {
      this.currentHoverIndex = null;   // 鼠标离开时重置
    },
    changeSceneBackground(index) {
      this.currentHoverIndex = index;  // 鼠标移入具体行业时更换背景
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;

  .homeBG {
    width: 100%;
    height: 800px;
    background-image: url('../img/bg1.webp');
    background-size: 100% 100%;
  }

  .bsright {
    width: 100%;
    max-width: 1300px;
    height: 500px;
    margin: 0 auto;
    padding: 30px 20px;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &:hover {
      .bsrightright {
        background-color: #a8232e;

        .bsr:hover {
          .bsb {
            background-color: #fff;
            transform: translateX(10px);
          }
        }
      }
    }

    .bsrightBox {
      display: flex;
      width: 100%;
      height: 100%;

      .bsrightImg {
        flex: 2.0;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: transform 0.3s ease;
        }
      }

      .bsrightright {
        flex: 1;
        background-color: #c92b37;
        padding: 51px 20px;
        transition: background-color 0.3s ease;

        .btzw {
          font-size: 36px;
          color: #fff;
          font-weight: 400;
          padding-bottom: 10px;
          text-align: center;
        }

        .btyw {
          font-size: 24px !important;
          color: #fff;
          text-align: center;
          font-weight: 400;
          letter-spacing: 0.5px;
          padding-bottom: 34px;
        }

        .bsr {
          height: 80px;
          font-size: 24px;
          font-family: -webkit-body;
          font-weight: 300;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 15px;
          margin-bottom: 10px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:last-child {
            margin-bottom: 0;
          }

          .bsa {
            flex: 1;
            transition: all 0.3s ease;
          }

          .bsb {
            width: 40px;
            height: 40px;
            border: #fff 1px solid;
            border-radius: 30px;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;

            &::after {
              content: '';
              width: 8px;
              height: 8px;
              background-color: transparent;
              border-top: 2px solid #fff;
              border-right: 2px solid #fff;
              transform: rotate(45deg);
              transition: all 0.3s ease;
            }
          }

          &:hover {
            .bsa {
              padding-left: 10px;
              font-weight: 400;
            }

            .bsb::after {
              border-color: #c92b37;
            }
          }
        }
      }
    }
  }

  .cationBox {
    width: 100%;
    margin-top: 50px;

    .cationContent {
      width: 100%;
      height: 600px;
      position: relative;
      overflow: hidden;
      transition: background-image 0.5s ease-in-out;

      .scene-grid {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 1fr);
        box-sizing: border-box;
        position: relative;
        z-index: 2;

        .scene-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(255, 255, 255, 0.6);
          text-align: center;
          cursor: pointer;

          img {
            width: 150px;
            height: 150px;
            margin-bottom: 15px;
            transition: transform 0.3s ease;
          }

          &:hover img {
            transform: scale(1.1);
          }

          .scene-label {
            font-size: 33px;
            font-weight: 500;
            color: #fff;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
          }

          &:nth-child(5) {
            grid-column: 2;
            grid-row: 1 / span 2;
            width: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .cationtext {
      text-align: center;
      font-size: 32px;
      font-weight: 300;
      margin-bottom: 30px;
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .home {
    .homeBG {
      height: 50vh;
      min-height: 300px;
      background-position: center;
    }

    .bsright {
      height: auto;
      padding: 20px 15px;
      margin-top: 20px;

      .bsrightBox {
        flex-direction: column;

        .bsrightImg {
          flex: none;
          height: 250px;
          margin-bottom: 20px;
        }

        .bsrightright {
          flex: none;
          padding: 30px 15px;

          .btzw {
            font-size: 28px;
            padding-bottom: 8px;
          }

          .btyw {
            font-size: 18px !important;
            padding-bottom: 25px;
          }

          .bsr {
            height: 60px;
            font-size: 18px;
            padding: 0 12px;
            margin-bottom: 8px;

            .bsb {
              width: 35px;
              height: 35px;

              &::after {
                width: 6px;
                height: 6px;
              }
            }

            &:hover .bsa {
              padding-left: 8px;
            }
          }
        }
      }
    }

    .cationBox {
      margin-top: 30px;

      .cationtext {
        font-size: 24px;
        padding: 0 15px;
        margin-bottom: 20px;

        &:last-child {
          font-size: 14px;
          margin-top: 8px;
        }
      }

      .cationContent {
        height: 70vh;
        min-height: 400px;

        .scene-grid {
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(3, 1fr);
          gap: 1px;

          .scene-item {
            img {
              width: 80px;
              height: 80px;
              margin-bottom: 10px;
            }

            .scene-label {
              font-size: 18px;
            }

            &:nth-child(5) {
              grid-column: 1 / span 2;
              grid-row: 3;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .home {
    .homeBG {
      height: 40vh;
      min-height: 250px;
    }

    .bsright {
      padding: 15px 10px;
      margin-top: 15px;

      .bsrightBox {
        .bsrightImg {
          height: 200px;
          margin-bottom: 15px;
        }

        .bsrightright {
          padding: 20px 12px;

          .btzw {
            font-size: 24px;
          }

          .btyw {
            font-size: 16px !important;
            padding-bottom: 20px;
          }

          .bsr {
            height: 50px;
            font-size: 16px;
            padding: 0 10px;
            margin-bottom: 6px;

            .bsb {
              width: 30px;
              height: 30px;

              &::after {
                width: 5px;
                height: 5px;
              }
            }
          }
        }
      }
    }

    .cationBox {
      margin-top: 20px;

      .cationtext {
        font-size: 20px;
        margin-bottom: 15px;

        &:last-child {
          font-size: 12px;
        }
      }

      .cationContent {
        height: 60vh;
        min-height: 350px;

        .scene-grid {
          .scene-item {
            img {
              width: 60px;
              height: 60px;
              margin-bottom: 8px;
            }

            .scene-label {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>